import type { ProductHelpers } from './types';

export function useProductHelpers(): ProductHelpers {
  return {};
}
